// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapBadge, BootstrapIcon, BootstrapLink } from '../../../dsl/front';
import { PublicationDate } from '../PublicationDate';
import { ReadMoreLink } from '../ReadMoreLink';
import { ReadingTime } from '../ReadingTime';
import { TextListItem } from '../TextListItem/TextListItem';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let TextList = class TextList extends Vue {
    /**
     * Converts articles to MergedListItem format for TextListItem
     */
    get articleItems() {
        return this.articles.map((article, index) => ({
            type: 'article',
            component: '',
            data: article,
            props: {},
            position: index,
            key: `article-${article.id || index}`
        }));
    }
    get showBadge() {
        if (!this.listConfig) {
            return false;
        }
        if (typeof this.listConfig.showArticleTags === 'undefined') {
            return false;
        }
        return this.listConfig.showArticleTags;
    }
};
__decorate([
    Prop({ type: Array, required: true })
], TextList.prototype, "articles", void 0);
__decorate([
    Prop({ type: Object, required: false })
], TextList.prototype, "readMoreLink", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], TextList.prototype, "withoutBadge", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], TextList.prototype, "showPublicationDate", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], TextList.prototype, "showReadingTime", void 0);
__decorate([
    Prop({ type: Object, required: false, default: () => { return { showArticleTags: false }; } })
], TextList.prototype, "listConfig", void 0);
TextList = __decorate([
    Component({
        name: 'TextList',
        components: { BootstrapBadge, BootstrapIcon, BootstrapLink, PublicationDate, ReadMoreLink, ReadingTime, TextListItem },
        template: `
    <div v-if="articles && articles.length" class="text-list">
      <div class="text-list__container" :class="{ '--with-read-more' : readMoreLink }">
        <!-- Articles list -->
        <ul class="text-list__list list-unstyled">
          <TextListItem
            v-for="item in articleItems"
            :key="item.key"
            :item="item"
            :list-config="listConfig"
            :without-badge="withoutBadge"
            :show-publication-date="showPublicationDate"
            :show-reading-time="showReadingTime" />
        </ul>
        <!-- END | Articles list -->
      </div>

      <!-- "Read more" button -->
      <div v-if="readMoreLink" class="text-list__read-more-link">
        <ReadMoreLink :link="readMoreLink" />
      </div>
    </div>
  `
    })
], TextList);
export { TextList };
